import { PropsWithChildren, ReactNode, useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { onFilterChange } from 'hooks';
import { $Object } from 'types';
import { UserContext } from 'contexts';
import { FullpageSpinner } from 'components';
import { getRoute, isLogged } from 'utils';

import { MainLayoutNEW } from './MainLayoutNEW';
import { MainLayoutOLD } from './MainLayoutOLD';

export interface MainLayoutInterface {
  filters?: $Object;
  pageHeading?: ReactNode;
  onChange?: onFilterChange<$Object>;
  pageActions?: ReactNode;
  menuSections?: ReactNode;
}

export const MainLayout = ({ ...props }: PropsWithChildren<MainLayoutInterface>) => {
  const {
    role: { isClient },
    isLoading
  } = useContext(UserContext);

  if (!isLogged()) return <Navigate to={getRoute('ClientLogInPage')} replace />;

  if (isLoading) return <FullpageSpinner />;

  return isClient ? <MainLayoutNEW {...props} /> : <MainLayoutOLD {...props} />;
};
